import { WHATSNEW_STORAGE_KEY } from '../constants/storage'

var whatsNewData: any = []

export const setWhatsNew = data => {
  whatsNewData = data
}

export const getWhatsNew = () => {
  return whatsNewData
}

export const getWNLastVersion = () => {
  return Math.max.apply(
    Math,
    whatsNewData.map(function(o) {
      return o.version
    })
  )
}

export const getLastRead = () => {
  const lastRead: number =
    parseInt(window.localStorage.getItem(WHATSNEW_STORAGE_KEY) || '') | 0
  return lastRead
}
export const getUnread = () => {
  const notificationsCount = whatsNewData.filter(
    i => Number(i.version) > getLastRead()
  ).length
  return notificationsCount
}

export const setLastRead = () => {
  localStorage.setItem(WHATSNEW_STORAGE_KEY, String(getWNLastVersion()))
}
